export default __webpack_public_path__ + "static/media/SMS.4bae0352.png";